import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Leg, RfqLegSettings } from '@approot/models';

export function dcdFormValidator(
  leg: Leg,
  control: AbstractControl,
  tradingMode: boolean
): ValidationErrors | null {
  if (tradingMode) {
    return dcdFormValidatorTradingMode(leg, control);
  } else {
    return dcdFormValidatorNonTradingMode(leg, control);
  }
}

function dcdFormValidatorNonTradingMode(
  leg: Leg,
  control: AbstractControl
): ValidationErrors | null {
  // validates the form for dcd's
  // 2 our of 3 of margin, deposit rate, and conversion rate must be filled
  const ctrls = (control as FormGroup).controls;
  const margin = ctrls.margin.value;
  const depositRate = ctrls.depositRate.value;
  const conversionRate = ctrls.conversionRate.value;

  const t1 =
    margin &&
    leg.missingAttributeOnPricing !== 'margin' &&
    depositRate &&
    leg.missingAttributeOnPricing !== 'depositRate' &&
    (!conversionRate || leg.missingAttributeOnPricing === 'conversionRate');

  const t2 =
    margin &&
    leg.missingAttributeOnPricing !== 'margin' &&
    conversionRate &&
    leg.missingAttributeOnPricing !== 'conversionRate' &&
    (!depositRate || leg.missingAttributeOnPricing === 'depositRate');

  const t3 =
    depositRate &&
    leg.missingAttributeOnPricing !== 'depositRate' &&
    conversionRate &&
    leg.missingAttributeOnPricing !== 'conversionRate' &&
    (!margin || leg.missingAttributeOnPricing === 'margin');

  if (t1 || t2 || t3) {
    return null;
  }
  return { invalidEntry: { value: control.value } };
}

function dcdFormValidatorTradingMode(
  leg: Leg,
  control: AbstractControl
): ValidationErrors | null {
  const ctrls = (control as FormGroup).controls;
  const conversionRate = ctrls.conversionRate?.value;
  const depositRate = ctrls.depositRate?.value;

  if (
    depositRate &&
    leg.missingAttributeOnPricing !== 'depositRate' &&
    conversionRate &&
    leg.missingAttributeOnPricing !== 'conversionRate'
  ) {
    return null;
  }
  return { invalidEntry: { value: control.value } };
}

export function clearFirstEditedDcdAttribute(
  attribute: string,
  leg: Leg,
  form: FormGroup
) {
  // only 1 of margin, deposit rate and conversion rate are allowed to be filled in at once.
  // wipe the least recent value
  if (
    leg.lastEditedDcdAttribute !== attribute && // if we are not dealing with the last editted value
    leg.lastEditedDcdAttribute
  ) {
    if (
      form.get(leg.lastEditedDcdAttribute).value &&
      leg.missingAttributeOnPricing !== leg.lastEditedDcdAttribute
    ) {
      if (
        (attribute === 'margin' && // if the value is what we are on currently, figure out what should be wiped
          leg.lastEditedDcdAttribute === 'conversionRate') ||
        (attribute === 'conversionRate' &&
          leg.lastEditedDcdAttribute === 'margin')
      ) {
        form.get('depositRate').setValue('', { emitEvent: false }); // we should wipe this value
        leg.lastEditedDcdAttribute = 'depositRate';
      } else if (
        (attribute === 'depositRate' &&
          leg.lastEditedDcdAttribute === 'conversionRate') ||
        (attribute === 'conversionRate' &&
          leg.lastEditedDcdAttribute === 'depositRate')
      ) {
        form.get('margin').setValue('', { emitEvent: false });
        leg.lastEditedDcdAttribute = 'margin';
      } else if (
        (attribute === 'margin' &&
          leg.lastEditedDcdAttribute === 'depositRate') ||
        (attribute === 'depositRate' && leg.lastEditedDcdAttribute === 'margin')
      ) {
        form.get('conversionRate').setValue('', { emitEvent: false });
        leg.lastEditedDcdAttribute = 'conversionRate';
      }
    }
  }
  leg.lastEditedDcdAttribute = attribute;
}

export function canDcdPrice(
  rfqExecutionSettings: RfqLegSettings,
  form: FormGroup,
  loadingPrices: boolean,
  leg: Leg
): boolean {
  const formValues = form.value;
  return (
    !rfqExecutionSettings.rfqLeg &&
    ((!loadingPrices &&
      formValues.margin &&
      formValues.depositRate &&
      (!formValues.conversionRate ||
        leg.missingAttributeOnPricing === 'conversionRate')) ||
      (formValues.margin &&
        formValues.conversionRate &&
        (!formValues.depositRate ||
          leg.missingAttributeOnPricing === 'depositRate')) ||
      (formValues.depositRate &&
        formValues.conversionRate &&
        (!formValues.margin || leg.missingAttributeOnPricing === 'margin')))
  );
}
